export const horizontalNavBarDataHooks = {
  root: 'horizontal-nav-bar',
  title: 'horizontal-nav-bar-title',
  sideContent: 'horizontal-nav-bar-side-content',
  topContent: 'horizontal-nav-bar-top-content',
  dropdownTrigger: 'horizontal-nav-bar-dropdown-trigger',
  dropdownContent: 'horizontal-nav-bar-dropdown-content',
  dropdownItem: 'horizontal-nav-bar-dropdown-item',
  skeleton: 'horizontal-nav-bar-skeleton',
};
